import { IAddress, IUSPSResult } from './Domain';
const USPS = require('usps-webtools');

const usps = new USPS({
    server: 'https://secure.shippingapis.com/ShippingAPI.dll',
    userId: '411INFOR0155',
    ttl: 10000
});

class USPSClient {

    static cityStateLookupByZip(zipCode: string, callback: (err: any, result: any) => void) {
        usps.cityStateLookup(zipCode, callback);
    }

    static verify(address: IAddress, callback: (err: any, result: any) => void) {
        usps.verify({
            street1: address.street,
            street2: address.apartment,
            city: address.city,
            state: address.stateCode,
            zip: address.zipCode
          }, callback);
    }

    static verifyAddress(address: IAddress): Promise<IUSPSResult> {
        return new Promise(function (resolve, reject) {
            usps.verify({
                street1: address.street,
                street2: address.apartment,
                city: address.city,
                state: address.stateCode,
                zip: address.zipCode
            },
            (error: any, result: any) => {
                if (null === error) {
                    resolve(result);
                }
                else {
                    reject(error);
                }
            });
        });
    }

    static getAreaByZip(zipCode: string): Promise<IUSPSResult> {
        return new Promise(function (resolve, reject) {
            usps.cityStateLookup(zipCode, (error: any, result: IUSPSResult) => {
                if (null === error) {
                    resolve(result);
                }
                else {
                    reject(error);
                }
            });
        });
    }
}

export default USPSClient;